<div class="h-100">
  <router-outlet></router-outlet>
  <simple-notifications></simple-notifications> 
</div>